import React from "react";
import styled from "styled-components";
import { Button } from "@tyrannosaurustech/ui";
import useToast from "../../hooks/useToast";

const CopyButtonWrapper = styled.div`
  margin-left: 0.15rem;
  margin-right: 0.3rem;
  margin-top: auto;
`;

interface CopyButtonProps {
  textToCopy: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({ textToCopy }) => {
  const toast = useToast();

  const copyToClipboard = async () => {
    if (!textToCopy) return;
    await navigator.clipboard.writeText(textToCopy).then(() => {
      toast.success("Copied to clipboard");
    });
  };

  return (
    <CopyButtonWrapper>
      <Button
        base="tertiary"
        icon="DocumentDuplicateIcon"
        size="small"
        type="button"
        onClick={copyToClipboard}
      />
    </CopyButtonWrapper>
  );
};
